import {
  PharmacyLabRadiology,
  PharmacyLabRadiologyPreferenceTypeEnum,
} from "@/services";
import { PreferenceFormValues } from "./PatientLabPharmacyRadiologyFormDrawer";

const PREFERENCE_TYPES: string[] = Object.values(
  PharmacyLabRadiologyPreferenceTypeEnum
);

const isPreferenceType = (
  value: string
): value is PharmacyLabRadiologyPreferenceTypeEnum =>
  PREFERENCE_TYPES.includes(value);

export const toPharmacyLabRadiology = (
  values: PreferenceFormValues
): PharmacyLabRadiology => ({
  ...values,
  preferenceType: isPreferenceType(values.preferenceType)
    ? values.preferenceType
    : undefined,
});
